export default {
  //AWS s3 stuff
  bucket: 'lingomastery',
  region: "us-east-2",
  awsUrl: "s3.us-east-2.amazonaws.com",
  appName: 'Lingo Mastery'
}